import styled, { css } from 'styled-components'

import { Section as RootSection } from '@/components/business/market-shop/section'

export const Section = styled(RootSection)(
  () => css`
    // NOTE: using id selector to reuse component from lib but style it as needed in design
    #order-notes {
      height: 4.4rem;
    }
  `,
)

export const OptionsList = styled.ul(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['8']};
  `,
)
